import { themeConfig } from '@gap/shared/theme'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

interface AuthInvalidTokenProps {
   text: string
   canGoHome?: boolean
   content?: React.ReactNode
}

export default observer(function AuthInvalidToken(props: AuthInvalidTokenProps) {

   const navigateToOrgsDefault = useCallback(() => {
      window.location.href = window.location.origin
   }, [])

   return <>
      <WarningAmberOutlinedIcon sx={{ color: `${themeConfig.system.warning[600]}` }} fontSize="large" />
      <Typography variant="h6" sx={{ color: `${themeConfig.primary[900]}` }}>{props.text}</Typography>
      {props.content}
      {props.canGoHome &&
         <Button variant="contained" onClick={navigateToOrgsDefault} sx={{ width: '200px', my: 6 }}>Go home</Button>
      }
   </>
})
